var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-exit",on:{"click":function($event){$event.stopPropagation();return _vm.handleLogOut.apply(null, arguments)}}},[_c('img',{staticStyle:{"width":"27px","height":"27px"},attrs:{"src":require("@/assets/images/onlogin-icon.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }